import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { VendorModel } from './vendor.model'

const API_URL = environment.apiUrl

@Injectable({
  providedIn: 'root',
})
export class VendorService {
  constructor(private http: HttpClient) {}

  addVendor(vendor: VendorModel) {
    return this.http.post(API_URL + '/Vendor/CreateVendor', vendor, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  updateVendor(vendor: VendorModel) {
    
    return this.http.put(API_URL + '/Vendor/UpdateVendor', vendor, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  getAllVendors(): Observable<VendorModel[]> {
    return this.http.get(API_URL + '/Vendor/ReadVendors', {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  deleteVendor(vendor: VendorModel) {
    
    return this.http
      .delete(API_URL + '/Vendor/DeleteVendor', {
        headers: {},
        body: vendor,
        withCredentials: true
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }
}
